import { useAgentRuntime } from '@/context/AgentProvider'
import { defaultTranslations, type Translations } from '@/config/translations'

/**
 * Hook to access translations from the agent runtime config.
 * Falls back to default English translations if not provided.
 */
export const useTranslations = (): Translations => {
  const runtime = useAgentRuntime()
  return { ...defaultTranslations, ...(runtime.config.translations ?? {}) }
}
